import React, { Fragment } from 'react'
import { Badge, Button, spacer } from 'stylist'
import ProgressBar from 'components/ProgressBarV2'
import styled from 'react-emotion'

const uploadBadgeColor = state => {
  switch (state) {
    case 'uploading':
      return 'slate'
    case 'complete':
      return 'ocean'
    case 'error':
      return 'red'
    case 'cancelled':
      return 'orange'
    default:
  }
}

const UploadDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-column-gap: ${spacer(4)};
  align-items: center;
  margin-bottom: ${spacer(3)};
`

const UploadDetails = ({
  upload: { state, file, progress },
  onCancel,
  onRemove
}) => (
  <Fragment>
    <UploadDetailsContainer>
      <h6>
        {file.name} - {progress}%
      </h6>
      <Badge color={uploadBadgeColor(state)}>{state}</Badge>
      {state === 'uploading' && (
        <Button kind="danger" onClick={onCancel}>
          Cancel
        </Button>
      )}
      {(state === 'complete' || state === 'error' || state === 'cancelled') && (
        <Button kind="utility" onClick={onRemove}>
          Hide
        </Button>
      )}
    </UploadDetailsContainer>
    <ProgressBar progress={progress} />
  </Fragment>
)

export default UploadDetails



// WEBPACK FOOTER //
// ./src/routes/videos/components/UploadDetails.js